import valid from "card-validator";
import { object, string } from "yup";
import { Constants } from "config/constants";

export const validationSchema = object().shape({
  firstName: string().required("First name is required"),
  lastName: string().required("Last name is required"),
  email: string()
    .email("Invalid email address format")
    .required("Email is required"),
  mobileNumber: string().required("Phone number is required"),
  billingAddress: string().required("Billing address is required"),
  paymentMethod: string().required("Payment method is required"),
  mpesaPhoneNumber: string()
    .trim("Mobile number cannot include leading and trailing spaces")
    .min(12, "Mobile number must be exactly 12 characters")
    .max(12, "Mobile number must be exactly 12 characters")
    .when("paymentMethod", {
      is: (paymentMethod) => paymentMethod !== "mpesa",
      then: string().optional(),
      otherwise: string().required("Mobile number is required"),
    })
    .matches(Constants.PHONE_NUMBER_REGEX, "Phone number is not valid")
    .test("len", "Correct format is 254#########", (val) => {
      if (val) {
        return val.startsWith("254");
      } else return true;
    }),
  cardHolderName: string().when("paymentMethod", {
    is: (paymentMethod) => paymentMethod !== "card",
    then: string().optional(),
    otherwise: string().required("Card holder name is required"),
  }),
  cardNumber: string().when("paymentMethod", {
    is: (paymentMethod) => paymentMethod !== "card",
    then: string().optional(),
    otherwise: string()
      .matches(/^\d+$/, "Credit Card number is invalid")
      .test(
        "test-number",
        "Credit Card number is invalid",
        (value) => valid.number(value).isValid
      )
      .required("Card number is required"),
  }),
  expiryDate: string().when("paymentMethod", {
    is: (paymentMethod) => paymentMethod !== "card",
    then: string().optional().nullable(),
    otherwise: string().required("Expiry date is required").nullable(),
  }),
  cvv: string().when("paymentMethod", {
    is: (paymentMethod) => paymentMethod !== "card",
    then: string().optional(),
    otherwise: string()
      .required("CVV is required")
      .min(3, "Invalid cvv")
      .max(4, "Invalid cvv"),
  }),
});
